import { createContext, useState } from 'react';

const StoreContext = createContext();

const StoreProvider = ({ children }) => {
    const [cartQuantity, setCartQuantity] = useState(0);
    const [cartItems, setCartItems] = useState([]);

    const addToCart = (item) => {
        setCartQuantity(cartQuantity + 1);
        setCartItems([...cartItems, item]);
    };

    const removeFromCart = (item) => {
        setCartQuantity(cartQuantity - 1);
        setCartItems(cartItems.filter(cartItem => cartItem.id !== item.id));
    };

    return(
        <StoreContext.Provider value={{
            addToCart,
            removeFromCart,
            cartQuantity,
        }}>
            {children}
        </StoreContext.Provider>
    )
};

export default StoreProvider;